import {ChangeDetectorRef, Component, EventEmitter, Input} from "@angular/core";
import {
  AbstractProdGrid,
  IProdGrid,
  ProdGridColumnType,
  ProdGridHeaderButton,
  RequestEvent,
  ResponseEvent,
  ProdGridColumnTransforms
} from 'prod-grid';
import {DipColumn} from "../../../dip/dip-column";
import {GridMapService} from "../../../dip/map/grid-map.service";
import {MarkerDblClick} from 'prod-map';
import {CompanyEvents} from "../company-events";
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {HttpExtraParams} from "prod-shared";
import {SiteForm} from "./site-form/site-form";
import {RoleService} from "../../../services/role.service";
import {Role} from "../../../dip/role";
import {SiteService} from "../../../services/site.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['site.component.scss']
})
export class SiteComponent extends AbstractProdGrid implements IProdGrid {
  @Input() companyEvent$: EventEmitter<CompanyEvents>;
  siteMapTitle: string = this.translate.instant('company.site.map_title');
  prodGridTitle: string = this.translate.instant('company.site.grid_title');
  prodGridToolbarButtonsStatus = {
    isAddButtonDisabled: {
      role: [Role.ROLE_SITE_EDIT],
      disabled: !this.roleService.hasRole([Role.ROLE_SITE_EDIT])
    },
    isRemoveButtonDisabled: {
      role: [Role.ROLE_SITE_DELETE],
      disabled: !this.roleService.hasRole([Role.ROLE_SITE_DELETE])
    }
  };
  rowClasses = [{class: 'deleted', condition: function (record) {
      return record.isDeleted;
    }}]
  override prodGridForm = {
    component: SiteForm,
    style: {
      height: '70%',
      width: '60%'
    },
    editStyle: {
      height: '70%',
      width: '60%'
    }
  };

  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'address', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'description', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'latitude', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({property: 'longitude', type: ProdGridColumnType.NUMBER}),
    DipColumn.get({property: 'latLng', type: ProdGridColumnType.HIDDEN, editable: false}),
    DipColumn.get({
      property: 'isDeleted',
      type: this.roleService.hasRole([Role.ROLE_SYS]) ? ProdGridColumnType.CHECKBOX : ProdGridColumnType.HIDDEN,
      editable: false,
      transform: {
        transform: ProdGridColumnTransforms.TICK
      }
    })
  ];

  override prodGridHeaderButtons: ProdGridHeaderButton[] = [];

  constructor(protected override changeDetectorRef: ChangeDetectorRef,
              override prodGridDataService: SiteService,
              public gridMapService: GridMapService,
              private roleService: RoleService,
              public organizationTreeSelect: OrganizationTreeSelect,
              private translate: TranslateService) {
    super(changeDetectorRef);
    organizationTreeSelect.gridComponent = this;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.gridMapService.init(this);
  }

  ngOnDestroy() {
    this.organizationTreeSelect.gridComponent = null;
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    httpExtraParams = HttpExtraParams.addFilter(httpExtraParams, this.organizationTreeSelect.getHttpExtraParams(this.prodGridDataService));
    super.loadProdGridData(httpExtraParams);
  }

  prodMapEvents(event) {
    this.gridMapService.prodMapEvents(event);
    switch (event.constructor.name) {
      case MarkerDblClick.name: {
        this.companyEvent$.emit(CompanyEvents.SITE_DBL_CLICK);
        this.organizationTreeSelect.organizationTreeSelect$.next(<number>event.marker.id);
      }
    }
  }

  override outputActionEvents(event: { event: RequestEvent | ResponseEvent, value?: any }) {
    if (event.event !== ResponseEvent.RESPONSE_DBL_CLICK) {
      super.outputActionEvents(event);
    }

    switch (event.event) {
      case ResponseEvent.RESPONSE_DBL_CLICK: {
        this.companyEvent$.emit(CompanyEvents.SITE_DBL_CLICK);
        this.organizationTreeSelect.organizationTreeSelect$.next(<number>Array.from(event.value.getAll().keys())[0]);
        break;
      }
    }
    this.gridMapService.outputActionEvents(event);
  }
}
